import { ApiBase } from "../../base/_ApiBase";
import { ApiClient } from "../../base/_ApiClient";
import { BannerModel } from "../../models/banners/BannerModel";

export const BannerApi = new class BannerApi extends ApiBase<BannerModel>{
    constructor({ baseUrl }: { baseUrl: string; }) {
        super(baseUrl);
    }

}({ baseUrl: '/ads-items' });